<!-- login页面 code=105 getItem('isCompletionData') == null的时候跳转至该页面  未补全个人信息 -->
<template>
  <div style="width: 100%;min-height: 100vh;padding-top: 15px; padding-bottom: 20px; box-sizing: border-box; background-color: #fff">
    <el-form :rules="rules" ref="form" :model="sizeForm" label-width="0" style="width: 90%;margin: 10px auto;" class="info-form">
      <div class="com-font">*身份证号</div>
      <el-form-item prop="idCard">
        <el-input placeholder="请输入身份证号" :disabled="disabledIdCard" v-model="sizeForm.idCard"></el-input>
        <el-divider></el-divider>
        <!-- <div v-show="showId" style="color: red;">请输入身份证号</div>          -->
      </el-form-item>
      <el-form-item prop="studentNumber">
        <div class="com-font">学号</div>
        <el-input placeholder="请输入在校学号" v-model="sizeForm.studentNumber"></el-input>
        <el-divider></el-divider>
        <!-- <div v-show="showTid" style="color: red;">请输入学号</div> -->
      </el-form-item>

      <el-form-item prop="idCardPhoto">

        <div class="com-font">*个人证件照</div>
        <van-uploader :before-read="beforeRead" :after-read="afterRead">
          <div class="upLodeDiv" v-if="sizeForm.idCardPhoto == null || sizeForm.idCardPhoto == ''">
            <img src="../../assets/image/btn_shangchuan1_nor.png" alt="" class="upLodeImg">
          </div>
          <div class="upLodeDiv" v-else>
            <img :src="sizeForm.idCardPhoto" alt="" class="upLodeImg">
          </div>
        </van-uploader>
        <div class="tips">
          提示：
          <br>
          1.请您上传近期正面、免冠、清晰的电子证件照，作为您的校友卡头像； 2.照片一经上传不得修改，请您谨慎上传；
        </div>
      </el-form-item>

    </el-form>
    <el-button style="display: block;margin: 0 auto; margin-top: 10px;" class="lwork" type="primary" @click="commit">提交
    </el-button>
    <el-button style="display: block;margin: 0 auto; margin-top: 15px;" class="skip-work" type="text" @click="skipToIndex">跳过，直接去首页
    </el-button>

    <!-- 弹框 -->
    <div v-show="register" class="regSuccess">
      <div class="reg-com reg-short">注册成功</div>
      <div class="reg-com reg-long">恭喜您注册并认证校友身份成功， 请补全校友身份信息。</div>
    </div>

  </div>
</template>

<script>
import IdCheck from '../../assets/js/IdCheck'
import { dataURLtoFile } from '../../assets/js/dataURLtoFile'
export default {
  data() {
    const checkIdCard = (rule, value, callback) => {
      const ver15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
      const ver18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!value || value === '') {
        callback(new Error('不能为空'))
      } else {
        if (!ver15.test(value) && !ver18.test(value)) {
          callback(new Error('身份证号码格式错误'))
        } else {
          callback()
        }
      }
    }
    return {
      openid: localStorage.getItem('openid'),
      sizeForm: {
        // name:"",
        idCard: "",
        studentNumber: "",
        idCardPhoto: ''
      },
      // recompletion接口取到的图片url
      getApiUrl: '',
      showId: false,
      showTid: false,
      // 注册成功
      register: true,
      disabledIdCard: true,
      file: '',
      rules: {
        idCard: [
          { required: true, validator: checkIdCard, trigger: 'blur' }
        ],
        idCardPhoto: [
          { required: true, message: "请上传个人证件照", trigger: "blur" }
        ],
      },
    }
  },
  props: {
    form: {}
  },
  methods: {
    applyRouteIdCard() {
      const routeIdCard = (this.$route.query.idcard || '').trim()
      if (!routeIdCard) {
        return
      }
      this.sizeForm.idCard = routeIdCard
      this.disabledIdCard = true
    },
    commit() {
      this.$refs.form.validate((valid) => {
        console.log(58, valid);
        if (valid) {
          // 校验身份证是否合规
          let data = this.sizeForm.idCard.toUpperCase() //转换成大写
          if (IdCheck(data) == true) {
            this.autoAudit()
          } else {
            this.$toast('身份证号不符合规范，请检查')
          }
        }
      })
    },
    skipToIndex() {
      this.$router.push('/index')
    },
    async getData() {
      const res = await this.$http.get(`/xjcard/recompletion?openid=${this.openid}`)
      if (res.data != null) {
        this.sizeForm.idCard = res.data.idcard
        if (this.sizeForm.idCard) {
          this.disabledIdCard = true
        } else {
          this.disabledIdCard = false
        }
        this.sizeForm.studentNumber = res.data.student_num
        this.getApiUrl = res.data.url;
        if (this.getApiUrl == null || this.getApiUrl == '') {
          this.sizeForm.idCardPhoto = ''
        } else {
          this.sizeForm.idCardPhoto = this.getApiUrl
        }
      }
    },
    showPop() {
      let timer = setTimeout(() => {
        this.register = false;
      }, 1000)
    },
    // 审核
    autoAudit: async function () {
      this.$toast.loading('提交中')
      // 判断用户是否上传过照片，如果没有上传走这个逻辑，上传过直接调用新增
      if (this.getApiUrl == '' || this.getApiUrl == null) {
        let param = new window.FormData()
        param.append("file", this.file.file)
        param.append("user_id", window.localStorage.getItem("user_id"));
        const result = await this.$http.post("/upload/upload_all_img", param);
        this.$toast.clear()
        // 判断图片是否上传成功
        if (result.data.code === 0) {
          let uiForm = this.sizeForm
          delete uiForm.idCardPhoto
          uiForm.userId = localStorage.getItem("user_id")
          // 身份验证
          const res = await this.$http({
            url: "/xjcard/insertIdCardAndStudentNumber",
            method: "POST",
            params: uiForm
          })
          this.$toast.clear()
          if (res.data.code === 1) {
            this.$toast(res.data.msg)
            await this.$router.push("/completeInfo")
          } else if (res.data.code === 501) {
            await this.$router.push("/failAuthentication")
          } else {
            this.$toast(res.data.msg)
          }
        } else {
          this.$toast(result.data.msg)
        }
      } else {
        let uiForm = this.sizeForm
        delete uiForm.idCardPhoto
        uiForm.userId = localStorage.getItem("user_id")
        // 身份验证
        const res = await this.$http({
          url: "/xjcard/insertIdCardAndStudentNumber",
          method: "POST",
          params: uiForm
        })
        this.$toast.clear()
        if (res.data.code === 1) {
          this.$toast(res.data.msg)
          await this.$router.push("/completeInfo")
        } else if (res.data.code === 501) {
          await this.$router.push("/failAuthentication")
        } else {
          this.$toast(res.data.msg)
        }
      }
    },
    beforeRead(file) {
      //await this.checkImg(file);
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$toast("请上传 jpg,png 格式图片");
        return false;
      }
      if (file.size < 55182) {
        this.$toast("图片必须大于600*800像素");
        return false;
      }
      return true;
    },
    async afterRead(file) {
      // this.$toast.loading('上传中')
      if (file.file.size > 110000) {
        let fileName = file.file.name;
        // 创建Canvas对象(画布)
        let canvas = document.createElement('canvas')
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext('2d')
        // 创建新的图片对象
        let img = new Image()
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content
        // 监听浏览器加载图片完成，然后进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = 600
          canvas.height = 800
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，600，800是将图片按给定的像素进行缩小。*/
          /* 如果不指定缩小的像素，图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后得到的图片就是张局部图。图片小于画布就会有黑边。*/
          context.drawImage(img, 0, 0, 600, 800)
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92)
          file.file = dataURLtoFile(file.content, fileName);
          console.log(file)
          this.sizeForm.idCardPhoto = file.content
          this.file = file
        }
      } else {
        this.sizeForm.idCardPhoto = file.content
        this.file = file
      }
    },
  },
  async created() {
    this.showPop()
    await this.getData()
    this.applyRouteIdCard()
    console.log('uid', window.localStorage.getItem("user_id"));

  },
}

</script>

<style lang="less">
.com-font {
  font-size: 1.3rem;
  color: #333333;
  // margin-bottom: 15px;
}

.info-form {
  .el-input__inner {
    border: 0 !important;
  }

  .el-divider--horizontal {
    margin: 0 !important;
    margin-bottom: 10px !important;
  }
}

.lwork {
  width: 80%;
  background-color: #00706E;
  height: 35px;
  font-size: 20px;
  color: #fff;
  margin: 0 auto;
  border-radius: 35px;
  padding: 0;
}

.skip-work {
  width: 80%;
  color: #333333;
  margin: 0 auto;
  text-align: center;
  padding: 0;
}

// 分割线
.el-divider--horizontal {
  margin-top: 0px;
  margin-bottom: 0px !important;
}

.el-divider {
  background-color: #aaaaaa;
}

// 弹框
.regSuccess {
  position: absolute;
  top: 120px;
  width: 88%;
  left: 6%;
  height: 185px;
  opacity: 0.8;
  background-color: #000000;
  border-radius: 22px;
  margin: 0 auto;
  display: block;
  text-align: center;

  .reg-com {
    color: #fff;
    margin: 30px 0;
    text-align: center;
  }

  .reg-short {
    font-size: 24px;
  }

  .reg-long {
    font-size: 17px;
    width: 95%;
    margin: 0 auto;
  }
}

.el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin: auto;
}

.el-button + .el-button {
  margin: auto;
}

.el-form-item__error {
  padding-top: 0 !important;
}

.upLodeDiv {
  width: 70%;
  margin: 15px auto;

  .upLodeImg {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IdentitAuthentication/completePersonInfo.vue